// extracted by mini-css-extract-plugin
export var galleryMasonryImageWrapper = "t_jP d_jP d_ct";
export var galleryMasonryImage = "t_jN d_jN d_v d_bQ d_dz";
export var alignLeft = "t_p4 d_fn d_bF d_dt";
export var alignCenter = "t_bN d_fp d_bC d_dv";
export var alignRight = "t_p5 d_fq d_bG d_dw";
export var galleryContainer = "t_sM d_dV";
export var galleryContainerFull = "t_sN d_dS";
export var galleryRowWrapper = "t_sP d_cb";
export var galleryGuttersImage = "t_jR d_jR d_J d_ct";
export var galleryNoGuttersImage = "t_jQ d_jQ d_J d_cC";
export var galleryTextGutters = "t_jL d_jL d_cv";
export var galleryTextNoGutters = "t_jM d_jM d_cv";
export var galleryTextMasonry = "t_sQ d_jL d_cv";
export var galleryImageWrapper = "t_sR d_ff d_Y";
export var descText = "t_sS d_jS d_Z d_8 d_6 d_7 d_m";
export var guttersDesc = "t_sT";